import { Component, inject, OnInit, OnDestroy, DoCheck } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { filter } from 'rxjs/operators';
import { contexts } from 'src/app/enums/contexts';
import { technos, technosName } from 'src/app/enums/technos';
import { Project } from 'src/app/models/project';
import { API_SERVICE_TOKEN } from 'src/app/service/api.service';
import { wbceKeycloakScopes } from 'src/app/service/keycloak.service';
import { WorkspaceManagerService } from 'src/app/service/workspace-manager.service';
import {
    ROLE_SEP,
    UNDEFINED_ROLE,
} from 'src/app/shared-components/wbce-button/wbce-button.component';
import {
    app_logo,
    navigationGlobal,
    navigationService,
} from '../../enums/navigation';
import { Service } from '../../models/service';
import { WbceServiceManagerService } from '../../service/wbce-service-manager.service';

export const ALL_SERVICES = 'All services';

@Component({
    selector: 'app-left-navigation-list',
    templateUrl: './left-navigation-list.component.html',
    styleUrls: ['./left-navigation-list.component.scss'],
    standalone: false
})
export class LeftNavigationListComponent implements OnInit, OnDestroy, DoCheck {
    subs: Subscription[] = [];

    menu = [];
    app_logo = app_logo;
    technosName = technosName;
    ALL_SERVICES = ALL_SERVICES;

    currentActiveRoute = 'infra';

    readRole: string = '';
    undefinedRole: string = UNDEFINED_ROLE;

    contexts: contexts[] = [];
    currentContext: contexts = contexts.STAGING;

    projects: Project[] = [];
    currentProject: Project;
    projectName: string = '';

    services: Service[] = [];
    currentService: Service;
    serviceName: string = '';

    servicesToDisplay: Service[] = [];
    servicesMenu: { name: string; isDisabled: boolean }[] = [];

    tools = [
        {
            name: 'Config manager - Infisical',
            logo: 'infisical',
            id: technos.INFISICAL,
        },
    ];
    /*
,
    {
      name : "Apache APASIX",
      url : "https://apisix.apache.org",
      logo : "apasix"
    }
  */

    router = inject(Router);
    route = inject(ActivatedRoute);
    private api = inject(API_SERVICE_TOKEN);
    wbceServiceManager = inject(WbceServiceManagerService);
    workspaceService = inject(WorkspaceManagerService);

    constructor() {}

    ngOnInit(): void {
        this.subs.push(
            this.router.events
                .pipe(filter((e) => e instanceof NavigationEnd))
                .subscribe(this.onRouteChange.bind(this)) // ajouter un pipe pour filtrer les events non necessaires ?
        );

        this.subs.push(
            this.wbceServiceManager.currentProject$.subscribe(
                this.onWBCEProjectChange.bind(this)
            )
        );
        this.onRouteChange();
    }
    ngOnDestroy() {
        for (const s of this.subs) {
            s.unsubscribe();
        }
    }

    ngDoCheck() {
        // console.log('Change detection triggered');
    }

    onWBCEProjectChange() {
        this.projects = this.workspaceService?.projects; // update before wbceServiceManager
        this.services = this.wbceServiceManager.getServices();

        this.servicesMenu = [{ name: ALL_SERVICES, isDisabled: false }];
        this.services.forEach((s) => {
            this.servicesMenu.push({
                name: s.calculatedDisplayName,
                isDisabled: s.isDisabled(),
            });
        });

        this.currentService = this.wbceServiceManager.currentService;
        this.servicesToDisplay = this.wbceServiceManager.getServicesToDisplay();

        this.currentContext = this.wbceServiceManager.currentContext;
        this.contexts = this.wbceServiceManager.contexts;

        this.currentProject = this.wbceServiceManager.currentProject;

        this.serviceName =
            this.currentService?.calculatedDisplayName || ALL_SERVICES;
        this.projectName = this.currentProject.projectName;

        this.readRole =
            this.currentProject._id +
            ROLE_SEP +
            contexts.PRODUCTION +
            ROLE_SEP +
            wbceKeycloakScopes.GET;

        this.menu = this.currentService ? navigationService : navigationGlobal;
    }

    onRouteChange() {
        this.currentActiveRoute = this.route.firstChild.snapshot.url[0].path;
    }

    onProjectServiceSelected() {
        const lastPartOfUrl = this.route.firstChild.snapshot.url[0].path; //Certes...
        this.router.navigate(
            [
                '../../..',
                this.projectName,
                this.serviceName,
                this.currentContext,
                lastPartOfUrl,
            ],
            { relativeTo: this.route }
        );
    }

    openContentInNewTab(service: Service, context: contexts) {
        this.api.getUrl(service, context).subscribe((url) => {
            if (url) window.open(url, '_blank');
        });
    }

    openToolInNewTab(tool: any) {
        if (tool.id === technos.INFISICAL) {
            this.workspaceService.openInfisicalService();
        }
        /* this.api.getToolUrl().subscribe(url=>{
        if(url)window.open(url, '_blank');
      })*/
    }
}
